import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineHomeWork } from "react-icons/md";
import { UserImageContext } from "../context/usecontextImage";
import FloatingMenu from "./Floatingmenu";
import { MdOutlineDirectionsCarFilled } from "react-icons/md";
import { MdOutlineChecklist } from "react-icons/md";
import { BsFillBuildingsFill } from "react-icons/bs";
import { FaBuildingUser } from "react-icons/fa6";
import { IoCarSharp } from "react-icons/io5";
import { MdRealEstateAgent } from "react-icons/md";
import { AiFillControl } from "react-icons/ai";
import { usecontextUser } from "../context/usecontextUser";
import axios from "axios";
function ResponsiveAppBar() {
  const { userImage, updateUserImage } = React.useContext(UserImageContext);
  const { logout, user } = React.useContext(usecontextUser)
  const [username, setUsername] = React.useState(null);
  const [usertype, setUsertype] = React.useState(null);
  const [usergender, setUsergender] = React.useState(null);
  const [userid, setUserid] = React.useState(null);
  const [useremail, setUseremail] = React.useState(null);
  const [token, setToken] = React.useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();


  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const userId = localStorage.getItem("userId")
  console.log("userid",userId);
  const { userr } = React.useContext(usecontextUser);
const userrid = userr?.id;
  const tok = localStorage.getItem("token")
  React.useEffect(() => {

    setUserid(userId);
    setUsername(user.name);
    setUseremail(user.email);
    setUsergender(user.gender);
    setUsertype(user.user_type);
    setToken(tok);
    console.log("tok", tok);

  },);
  const apilink = process.env.REACT_APP_API_URL + "logout"
  const handleLogout = async (e) => {

    e.preventDefault();

    try {
      await axios.post(apilink,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      updateUserImage("");

    } catch (error) {
      console.error("Login failed:", error);
      alert("login failed");
    }

    logout()
localStorage.removeItem("token")
    navigate("/");
  };

  console.log(user);


  const pages = [

    t("nav.signup"),
    t("nav.signin"),
    t("nav.realestate"),
    t("nav.cars"),

    t("nav.adminpanal"),
    t("nav.developer"),
    t("nav.project"),
    t("drawerProject.managed"),

  ];
  const settings = [t("nav.profile"), t("nav.logout")];
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (index) => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      style={{ backgroundColor: "#fff", color: "#000" }}
      position="static"
    >
      <Container maxWidth="x">
        <Toolbar disableGutters>
          <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            onClick={() => {
              navigate("/");
            }}
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "Oswald,Cairo, sans-serif",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "#000",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            LOGO
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="#000"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page, index) =>
                index > 1 ? (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#000",
                        fontFamily: "Oswald,Cairo, sans-serif",
                        fontWeight: "300",
                      }}
                    >
                      {page}
                    </Typography>
                  </MenuItem>
                ) : (
                  ""
                )
              )}
            </Menu>
          </Box>
          <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            onClick={() => {
              navigate("/");
            }}
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "Oswald,Cairo, sans-serif",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "#000",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            <Button
              onClick={() => {
                navigate("/");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <MdRealEstateAgent size={24} />   {pages[2]}
            </Button>

            <Button
              onClick={() => {
                navigate("/cars");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <IoCarSharp size={24} />    {pages[3]}
            </Button>
            <Button
              onClick={() => {
                navigate("/projectpage");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <BsFillBuildingsFill size={24} />    {pages[6]}
            </Button>
          { userId == 1 && <Button
              onClick={() => {
                navigate("/management");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <AiFillControl size={24} />    {pages[7]}
            </Button>}
            <Button
              onClick={() => {
                navigate("/developerpage");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <FaBuildingUser size={24} />    {pages[5]}
            </Button>
            {userId == 1 ? <Button
              onClick={() => {
                navigate("/admin");
              }}
              sx={{
                my: 2,
                color: "black",
                display: "block",
                fontSize: 18,
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "300",
              }}
            >
              <MdOutlineChecklist size={24} />    {pages[4]}
            </Button>:""}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            {userid ? (
              " "
            ) : (
              <Button
                onClick={() => {
                  navigate("/Signup");
                }}
                sx={{
                  my: 2,
                  color: "black",
                  display: "block",
                  fontSize: 16,
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
              >
                {pages[0]}
              </Button>
            )}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            {userid ? (
              ""
            ) : (
              <Button
                onClick={() => {
                  navigate("/Signin");
                }}
                sx={{
                  my: 2,
                  color: "black",
                  display: "block",
                  fontSize: 16,
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
              >
                {pages[1]}
              </Button>
            )}
          </Box>

          {userid ? (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    alt="Remy Sharp"
                    src={userImage}
                  />
                </IconButton>
              </Tooltip>

              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem onClick={() => { navigate('/profile') }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontFamily: "Oswald,Cairo, sans-serif",
                      fontWeight: "300",
                    }}
                  >
                    {settings[0]}
                  </Typography>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontFamily: "Oswald,Cairo, sans-serif",
                      fontWeight: "300",
                    }}
                  >
                    {settings[1]}
                  </Typography>
                </MenuItem>
              </Menu>
            </Box>
          ) : (
            ""
          )}
          <Box sx={{ flexGrow: 0 }}>
            <LanguageSwitcher />
          </Box>
        </Toolbar>
      </Container>


      {userid ? (

        <FloatingMenu />
      ) : (
        ''
      )}
    </AppBar>
  );
}
export default ResponsiveAppBar;
